import { DoorConfigurator, type DoorConfiguratorProps } from "@countdown/door-editor";
import type { ReactElement } from "react";

import { ParticipantFrame } from "@/components/ParticipantFrame";
import { useSaveSection } from "@/components/SaveBar";

/**
 * The door configurator (D37) as the backoffice binds it: the window in the frame with the
 * participant stylesheet, and the plain save in the save bar of the action's tab. The
 * configurator itself lives in `@countdown/door-editor`, so the sponsor portal binds the
 * same one to its own API.
 */
export function DoorEditor({
  previewTitle,
  ...props
}: Omit<DoorConfiguratorProps, "frame" | "joinSaveBar"> & {
  /** The name of the preview frame, e.g. "Vorschau des Türchen-Fensters". */
  readonly previewTitle: string;
}): ReactElement {
  return (
    <DoorConfigurator
      {...props}
      joinSaveBar={useSaveSection}
      frame={(preview) => <ParticipantFrame title={previewTitle}>{preview}</ParticipantFrame>}
    />
  );
}
